/**
 * Generate consistent avatar gradient color based on name hash.
 * Used across the app for client avatars in:
 * - Client list items
 * - Inbox chat list
 * - Chat header
 *
 * The same name will always produce the same color, ensuring visual consistency.
 *
 * @param {string} name - The name to generate a color for
 * @returns {{ bg: string, label: string }} Object with CSS gradient background and color label
 */
const AVATAR_COLORS = [
  { bg: 'linear-gradient(135deg, #3AA4FC 0%, #2B8FE0 100%)', label: 'blue' },
  { bg: 'linear-gradient(135deg, #7FBD31 0%, #5FA020 100%)', label: 'green' },
  { bg: 'linear-gradient(135deg, #9B59B6 0%, #8E44AD 100%)', label: 'purple' },
  { bg: 'linear-gradient(135deg, #FC8333 0%, #E67020 100%)', label: 'orange' },
  { bg: 'linear-gradient(135deg, #479C83 0%, #3A8A72 100%)', label: 'teal' },
  { bg: 'linear-gradient(135deg, #E74C3C 0%, #C0392B 100%)', label: 'red' },
  { bg: 'linear-gradient(135deg, #F39C12 0%, #D68910 100%)', label: 'yellow' },
  { bg: 'linear-gradient(135deg, #1ABC9C 0%, #16A085 100%)', label: 'cyan' },
];

export const getAvatarColor = name => {
  const hash = (name || '').split('').reduce((acc, char) => acc + char.charCodeAt(0), 0);
  return AVATAR_COLORS[hash % AVATAR_COLORS.length];
};

export default getAvatarColor;
